/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, callbacks = [];
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId])
/******/ 				callbacks.push.apply(callbacks, installedChunks[chunkId]);
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules);
/******/ 		while(callbacks.length)
/******/ 			callbacks.shift().call(null, __webpack_require__);
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// object to store loaded and loading chunks
/******/ 	// "0" means "already loaded"
/******/ 	// Array means "loading", array contains callbacks
/******/ 	var installedChunks = {
/******/ 		0:0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId, callback) {
/******/ 		// "0" is the signal for "already loaded"
/******/ 		if(installedChunks[chunkId] === 0)
/******/ 			return callback.call(null, __webpack_require__);
/******/
/******/ 		// an array means "currently loading".
/******/ 		if(installedChunks[chunkId] !== undefined) {
/******/ 			installedChunks[chunkId].push(callback);
/******/ 		} else {
/******/ 			// start chunk loading
/******/ 			installedChunks[chunkId] = [callback];
/******/ 			var head = document.getElementsByTagName('head')[0];
/******/ 			var script = document.createElement('script');
/******/ 			script.type = 'text/javascript';
/******/ 			script.charset = 'utf-8';
/******/ 			script.async = true;
/******/
/******/ 			script.src = __webpack_require__.p + "partial." + ({}[chunkId]||chunkId) + ".js";
/******/ 			head.appendChild(script);
/******/ 		}
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/assets/build/js/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * main.js
	 * Base loader (the actual starting point is in app.js).
	 * @see {@link http://usejsdoc.org} for information about comments standard used.
	  * @version 1.0.7
	 */
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = function (app) {
		'use strict';
	
		app.init();
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* eslint new-cap: "off" */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(4),
		__webpack_require__(3),
		__webpack_require__(6),
		__webpack_require__(8),
		__webpack_require__(9),
		__webpack_require__(2),
		__webpack_require__(10),
		__webpack_require__(12),
		__webpack_require__(13),
		__webpack_require__(14)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function (toggleLink, utils, dropdown, autoSubmit, checkboxRequiredGroup, jumptotop, acceptCookies, nanoajax, autoComplete) {
		'use strict';
	
		/**
		 * App
		 * This is the initialization file for all scripts.
		 * @version 1.0.7
		 * @see {@link http://youmightnotneedjquery.com/}
		 * @exports app
		 */
		var app = {
	
			/**
			 * The initialization function for this module.
			 * @public
			 */
			init: function () {
				console.log("HEJ");
	
				// Initiates the requestanimationframe polyfill
				utils.RAFPolyfill();
	
				// Initiates the DOMParser polyfill
				utils.DOMParserPolyfill();
	
				// Init toggle content
				toggleLink.init();
	
				// Init dropdown
				dropdown.init();
	
				// Init autosubmit
				autoSubmit.init();
	
				// Init checkboxRequiredGroup
				checkboxRequiredGroup.init();
	
				// Init Jump to top
				jumptotop.init();
	
				// Init accept cookies
				acceptCookies.init();
	
				// Init enter-press handle for checkboxes/radios
				this._initCheckboxRadioEnterPress();
	
				// Init autosize
				this._initAutoSize();
	
				// Init Back-link
				this._initBacklink();
	
				// Init Kolada integration
				//this._initKoladaIntegration();
	
				// Init Readspeaker integration
				this._initReadspeaker();
	
				// Init Vergic integration
				//this._initVergic();
	
				// Init Gismo (map) integration
				//this._initMap();
	
				// Init IsyMap integration
				//this._initIsyMap();
	
				// Init Leave site button
				//this._initLeaveSiteButton();
	
				// Init datepicker
				this._initDatepicker();
	
				// Init loadContent
				this._initLoadContent();
	
				// Init trigger
				this._initTrigger();
	
				// Init loadMore
				this._initLoadMore();
	
				// Init ajaxForm
				this._initAjaxForm();
	
				// Init episerverForm
				this._initEpiserverForm();
	
				// Init search tracking
				this._initSearchTracking();
	
				// Init compareList
				//this._initCompareList();
	
				// Init compareTable
				//this._initCompareTable();
	
				// Init anchorScroll
				this._initAnchorScroll();
	
				// Init rte table wrapp
				this._initRteTableWrap();
	
				// Init autocomplete
				this._initAutocomplete();
	
				// Init browser bug fixes
				this._browserBugFixes();
	
				// If pinboard mode (Anslagstavla), load some extras.
				//this._initPinboardMode();
	
	
				// this._initYoutube();
			},
	
			// _initYoutube: function() {
			// 	var iframes = document.querySelectorAll('.responsive-iframe iframe');
	
			// 	var tag = document.createElement('script');
	
			// 	tag.src = "https://www.youtube.com/iframe_api";
			// 	var firstScriptTag = document.getElementsByTagName('script')[0];
			// 	firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
	
			// 	if (iframes.length > 0) {
			// 		var player;
			// 		window.onYouTubeIframeAPIReady = function () {
			// 			console.log('here');
						
			// 			utils.forEach(iframes, function (iframe) {
			// 				player = new YT.Player(iframe.getAttribute('id'), {
			// 					events: {
			// 						onStateChange: onPlayerStateChange
			// 					}
			// 				});
			// 			});
			// 		};
	
			// 		var onPlayerStateChange = function (event) {
			// 			if (event.data == 0) //video ended
			// 				player.stopVideo();
			// 		};
		
			// 	}
			// },
	
	
			/**
			 * Function that initiates autosizing on textareas.
			 * @private
			 */
			_initAutoSize: function () {
				var textareas = document.querySelectorAll('textarea');
	
				if (textareas.length > 0) {
					__webpack_require__.e/* require */(1, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(15)]; (function (autosize) {
						autosize(textareas);
					}.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));});
				}
			},
	
	
			/**
			 * Select the focused checkbox/radio with enter-press (instead of submitting the form).
			 * @private
			 */
			_initCheckboxRadioEnterPress: function () {
				// Checkboxes
				utils.forEachElement('input[type="checkbox"]', this._checkboxRadioEnterPressAddEvent);
	
				// Radio buttons
				utils.forEachElement('input[type="radio"]', this._checkboxRadioEnterPressAddEvent);
			},
	
	
			/**
			 * Adds a keydown event to prevent submitting the form on enter-press.
			 * @param {Object} el - A DOM node.
			 * @see {@link module:app._initCheckboxRadioEnterPress}
			 * @private
			 */
			_checkboxRadioEnterPressAddEvent: function (el) {
				utils.addEventListener(el, 'keydown', function (event) {
					var charCode = (typeof event.which === 'number') ? event.which : event.keyCode;
	
					if (charCode === 13) {
						if (event.preventDefault) { event.preventDefault(); } else { event.returnValue = false; }
	
						if (el.getAttribute('type') === 'radio') {
							el.checked = true;
						} else {
							el.checked = !el.checked; // Toggle checked
						}
					}
				});
			},
	
	
			/**
			 * Function that wraps all tables in rte with a div to enable the scroll-feature in mobile.
			 * @private
			 */
			_initRteTableWrap: function () {
				utils.forEachElement('.t-rte table', function (el) {
					var wrapper = document.createElement('div');
					utils.addClass(wrapper, 'table-scrollable');
					utils.wrap(el, wrapper);
				});
			},
	
	
			/**
			 * Function that initiates the Back link functionality.
			 * @private
			 */
			_initBacklink: function () {
				utils.forEachElement('[data-type="backlink"]', function (el) {
					utils.addEventListener(el, 'click', function (event) {
						if (event.preventDefault) { event.preventDefault(); } else { event.returnValue = false; }
						window.history.back();
					});
				});
			},
	
	
			/**
			 * Function that initiates the Kolada integration.
			 * @private
			 */
			_initKoladaIntegration: function () {
				var koladaNode = document.getElementById('KoladaVisualizerPlaceHolder');
	
				if (koladaNode !== null) {
					__webpack_require__.e/* require */(2, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(16)]; (function (koladaIntegration) {
						koladaIntegration.init(koladaNode);
					}.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));});
				}
			},
	
	
			/**
			 * Function that initiates the "Leave site" functionality.
			 * @private
			 */
			_initLeaveSiteButton: function () {
				var leaveSiteButtonNode = document.getElementById('leave-site-button');
	
				if (leaveSiteButtonNode !== null) {
					__webpack_require__.e/* require */(3, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(18)]; (function (leaveSiteButton) {
						leaveSiteButton.init(leaveSiteButtonNode);
					}.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));});
				}
			},
	
	
			/**
			 * Function that initiates the "Readspeaker" integration.
			 * @private
			 */
			_initReadspeaker: function () {
				var readspeakerLink = document.getElementById('readspeaker-link');
	
				if (readspeakerLink !== null) {
					__webpack_require__.e/* require */(4, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(19)]; (function (readspeaker) {
						readspeaker.init(readspeakerLink);
					}.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));});
				}
			},
	
	
			/**
			 * Function that initiates the "Vergic" (chat) integration.
			 * @private
			 */
			_initVergic: function () {
				if (mainConfig.vergic !== undefined && mainConfig.vergic.enabled === true && mainConfig.vergic.url !== undefined && mainConfig.vergic.guid !== undefined) {
					var s = document.createElement('script');
					s.type = 'text/javascript';
					s.src = mainConfig.vergic.url + '/' + mainConfig.vergic.guid + '/ps.js';
					document.getElementsByTagName('head')[0].appendChild(s);
				}
			},
	
	
			/**
			 * Function that initiates the "Gismo" (map) integration.
			 * @private
			 */
			_initMap: function () {
				var mapNode = document.getElementById('gismoMap');
	
				if (mapNode !== null) {
					__webpack_require__.e/* require */(5, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(20)]; (function (map) {
						map.init(mapNode);
					}.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));});
				}
			},
	
	
			/**
			 * Function that initiates the "Gismo" (map) integration.
			 * @private
			 */
			_initIsyMap: function () {
				var mapNode = document.querySelector('[data-type="isymap"]');
	
				if (mapNode !== null) {
					var scriptTag = document.createElement('script');
					scriptTag.setAttribute('src', 'https://karta.huddinge.se/PublikKommunkarta/isymap.js?callback=initMap');
					scriptTag.setAttribute('type', 'text/javascript');
					scriptTag.setAttribute('rel', 'preload');
					document.head.appendChild(scriptTag);
	
					__webpack_require__.e/* require */(6, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(21)]; (function (map) {
						map.init(mapNode);
					}.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));});
				}
			},
	
	
			/**
			 * Function that initiates the datepicker.
			 * @private
			 */
			_initDatepicker: function () {
				var dateInputs = document.querySelectorAll('[data-type="datepicker"]');
	
				if (dateInputs.length > 0) {
					__webpack_require__.e/* require */(7, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(22)]; (function (datepicker) {
						datepicker.init(dateInputs);
					}.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));});
				}
			},
	
	
			/**
			 * Function that initiates the load more functionality.
			 * @private
			 */
			_initLoadMore: function () {
				var el = document.querySelector('[data-type="loadMore"]');
	
				if (el !== null) {
					__webpack_require__.e/* require */(8, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(24)]; (function (loadMore) {
						loadMore.init(el);
					}.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));});
				}
			},
	
	
			/**
			 * Function that initiates the ajax-form functionality.
			 * @private
			 */
			_initAjaxForm: function () {
				var els = document.querySelectorAll('[data-type="ajaxForm"]');
	
				if (els.length > 0) {
					__webpack_require__.e/* require */(10, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(56)]; (function (AjaxForm) {
						for (var i = 0; i < els.length; i++) {
							var el = els[i],
								ajaxForm = new AjaxForm();
	
							if (el.getAttribute('data-ajaxform-initiated') === null) {
								ajaxForm.init(el);
								el.setAttribute('data-ajaxform-initiated', true);
							}
						}
					}.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));});
				}
			},
	
	
			/**
			 * Function that initiates the episerver form functionality.
			 * @private
			 */
			_initEpiserverForm: function () {
				var els = document.querySelectorAll('[data-type="episerverForm"]');
	
				if (els.length > 0) {
					__webpack_require__.e/* require */(11, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(57)]; (function (EpiserverForm) {
						for (var i = 0; i < els.length; i++) {
							var el = els[i],
								episerverForm = new EpiserverForm();
	
							if (el.getAttribute('data-episerverform-initiated') === null) {
								episerverForm.init(el);
								el.setAttribute('data-episerverform-initiated', true);
							}
						}
					}.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));});
				}
			},
	
	
			/**
			 * Function that initiates the search tracking.
			 * @private
			 */
			_initSearchTracking: function () {
				var el = document.getElementById('search-list');
	
				if (el !== null) {
					__webpack_require__.e/* require */(12, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(59)]; (function (searchTracking) {
						searchTracking.init();
					}.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));});
				}
			},
	
	
			/**
			 * Function that initiates the loadcontent plugin.
			 * @private
			 */
			_initLoadContent: function () {
				var els = document.querySelectorAll('[data-type="loadContent"]');
	
				if (els.length > 0) {
					__webpack_require__.e/* require */(13, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(60)]; (function (loadContent) {
						loadContent.init(els);
					}.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));});
				}
			},
	
	
			/**
			 * Function that initiates the link-trigger functionality.
			 * This can be used to have on link to trigger a click on another.
			 * @private
			 */
			_initTrigger: function () {
				utils.addEventListener(document, 'click', function (event) {
					if (event.target.getAttribute('data-type') === 'trigger') {
						if (event.preventDefault) { event.preventDefault(); } else { event.returnValue = false; }
	
						var target = document.getElementById(event.target.getAttribute('data-target'));
	
						if (target.click) {
							target.click();
						} else {
							var clickEvent = document.createEvent('HTMLEvents');
							clickEvent.initEvent('click', true, true);
							target.dispatchEvent(clickEvent);
						}
					}
				});
			},
	
	
			_initAutocomplete: function () {
				new autoComplete({
					selector: 'input[name="q"]',
					source: function (term, response) {
						term = encodeURIComponent(term);
						var url = mainConfig.autocompleteUrl.indexOf('?') !== -1 ? mainConfig.autocompleteUrl + '&q=' + term : mainConfig.autocompleteUrl + '?q=' + term;
						nanoajax.ajax({
							method: 'GET',
							headers: {
								'X-Requested-With': 'XMLHttpRequest'
							},
							url: url
						},
						function (code, responseText) {
							var data = false,
								suggestions = [];
	
							if (code === 200) {
								try {
									data = JSON.parse(responseText);
								} catch (e) {}
	
								if (data) {
									for (var i = 0; i < data.suggestions.length; i++) {
										suggestions.push(data.suggestions[i].label);
									}
								}
							}
							response(suggestions);
						});
					}
				});
			},
	
	
			/**
			 * Function that initiates the ajax-form functionality.
			 * @private
			 */
			_initCompareList: function () {
				var el = document.querySelector('[data-type="compareList"]');
	
				if (el !== null) {
					__webpack_require__.e/* require */(14, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(61)]; (function (compareList) {
						compareList.init(el);
					}.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));});
				}
			},
	
	
			/**
			 * Function that initiates the compare-table functionality.
			 * @private
			 */
			_initCompareTable: function () {
				var el = document.querySelector('[data-type="compareTable"]');
	
				if (el !== null) {
					__webpack_require__.e/* require */(15, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(63)]; (function (compareTable) {
						compareTable.init(el);
					}.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));});
				}
			},
	
	
			/**
			 * Function that initiates the compare-table functionality.
			 * @private
			 */
			_initAnchorScroll: function () {
				var els = document.querySelectorAll('[data-type="anchorScroll"]');
	
				if (els.length > 0) {
					__webpack_require__.e/* require */(16, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(64)]; (function (anchorScroll) {
						anchorScroll.init(els);
					}.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));});
				}
			},
	
	
			/**
			 * Add some fixes for some specific browsers.
			 * @private
			 */
			_browserBugFixes: function () {
				var ua = navigator.userAgent.toLowerCase();
	
				if (ua.indexOf('android 4.') > -1) {
					utils.addClass(document.body, 'is-android-4');
				}
			}
		};
	
	
		return app;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = function (utils) {
		'use strict';
	
		/**
		 * Jump to top
		 * A plugin that displays the "jumptotop"-link when the user has scrolled down a bit.
		 * @exports jumptotop
		 */
		var jumptotop = {
	
			/** Top offset from which the link will be visible. */
			offsetTop: 135,
	
	
			/**
			 * The initialization function for this module.
			 * @param {Object} el - A DOM node.
			 * @public
			 */
			init: function () {
				var el = document.getElementById('jump-to-top');
	
				if (el !== null) {
					this._initJumptotop(el);
					this._initEvents(el);
				}
			},
	
	
			/**
			 * Initiates the jump to top visibility toggle.
			 * @param {Object} el - A DOM node.
			 * @private
			 */
			_initJumptotop: function (el) {
				var that = this,
					elIsVisible = false;
	
				window.onscroll = _decideVisibility;
	
				function _decideVisibility () {
					var scrollTop = window.pageYOffset;
					if (scrollTop > that.offsetTop && !elIsVisible) {
						utils.removeClass(el, 'is-hidden');
						elIsVisible = true;
					}
					else if (scrollTop < that.offsetTop && elIsVisible) {
						utils.addClass(el, 'is-hidden');
						elIsVisible = false;
					}
				}
			},
	
	
			/**
			 * Init click event, that scrolls to 1px from top (so we don't get an adressbar on_decide iPhone).
			 * @param {Object} el - A DOM node.
			 * @private
			 */
			_initEvents: function (el) {
				utils.addEventListener(el, 'click', function (event) {
					if (event.preventDefault) { event.preventDefault(); } else { event.returnValue = false; }
	
					utils.scrollToY(1, 1500, 'easeInOutQuint');
				});
			}
		};
	
	
		return jumptotop;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
		'use strict';
	
		/**
		 * Utilities
		 * Some good to have functions/helpers that works without jquery.
		 * @see {@link http://youmightnotneedjquery.com/}
		 * @version 1.1.1
		 * @exports utilities
		 */
		var utilities = {
	
			/**
			 * forEach function.
			 * @param {Object} arr - An array.
			 * @param {Object} fn - A function to be performed on each array item.
			 * @public
			 */
			forEach: function (arr, fn) {
				for (var i = 0; i < arr.length; i++) {
					fn(arr[i], i);
				}
			},
	
	
			/**
			 * forEach element function.
			 * @param {String} selector - A selector as a string.
			 * @param {Object} fn - A function to be performed on each DOM node that match the selector.
			 * @public
			 */
			forEachElement: function (selector, fn) {
				var elements = document.querySelectorAll(selector);
				for (var i = 0; i < elements.length; i++) {
					fn(elements[i], i);
				}
			},
	
	
			/**
			 * Get the browser to rerender.
			 * @param {String} browser - A class-name from the html-tag that defines a browser (eg 'lt-ie9', 'lt-ie8').
			 * @public
			 */
			rerenderElement: function (browser) {
				if (browser === undefined || (browser !== undefined && this.hasClass(document.documentElement, browser))) {
					document.body.className = document.body.className;
				}
			},
	
	
			/**
			 * wraps a DOM node with another node.
			 * @param {Object} el - The DOM node that should be wrapped.
			 * @param {Object} wrapper - A DOM node that wraps the other node.
			 * @public
			 */
			wrap: function (el, wrapper) {
				el.parentNode.insertBefore(wrapper, el);
				wrapper.appendChild(el);
			},
	
	
			/**
			 * Detects if an element has a certain class.
			 * @param {Object} el - A DOM node.
			 * @param {String} className - The classname to test.
			 * @public
			 */
			hasClass: function (el, className) {
				if (el.classList) {
					return el.classList.contains(className);
				} else {
					return new RegExp('(^| )' + className + '( |$)', 'gi').test(el.className);
				}
			},
	
	
			/**
			 * Adds a class to an element.
			 * @param {Object} el - A DOM node.
			 * @param {String} className - The classname to add.
			 * @public
			 */
			addClass: function (el, className) {
				if (el.classList) {
					el.classList.add(className);
				} else {
					el.className += ' ' + className;
				}
			},
	
	
			/**
			 * Removes a class from an element.
			 * @param {Object} el - A DOM node.
			 * @param {String} className - The classname to remove.
			 * @public
			 */
			removeClass: function (el, className) {
				if (el.classList) {
					el.classList.remove(className);
				} else {
					el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
				}
			},
	
	
			/**
			 * Removes a DOM node.
			 * @param {Object} el - A DOM node.
			 * @public
			 */
			remove: function (el) {
				if (el.remove) {
					el.remove();
				} else {
					el.parentNode.removeChild(el);
				}
			},
	
	
			/**
			 * Adds an event listener to an element.
			 * @param {Object} el - A DOM node.
			 * @param {String} eventName - An event name.
			 * @param {Object} handler - A function to be called when event fires.
			 * @public
			 */
			addEventListener: function (el, eventName, handler) {
				if (el.addEventListener) {
					if (eventName === 'focus' || eventName === 'blur') {
						el.addEventListener(eventName, handler, true);
					} else {
						el.addEventListener(eventName, handler);
					}
				} else {
					el.attachEvent('on' + eventName, function () {
						handler.call(el);
					});
				}
			},
	
	
			/**
			 * Removes an event listener from an element.
			 * @param {Object} el - A DOM node.
			 * @param {String} eventName - An event name.
			 * @param {Object} handler - The function that is called when event fires.
			 * @public
			 */
			removeEventListener: function (el, eventName, handler) {
				if (el.removeEventListener) {
					el.removeEventListener(eventName, handler);
				} else {
					el.detachEvent('on' + eventName, handler);
				}
			},
	
	
			/**
			 * Removes an event listener from an element.
			 * @param {Object} el - A DOM node.
			 * @param {String} eventName - An event name.
			 * @public
			 */
			triggerEvent: function (el, eventName) {
				var event; // The custom event that will be created
	
				if (document.createEvent) {
					event = document.createEvent('HTMLEvents');
					event.initEvent(eventName, true, true);
				} else {
					event = document.createEventObject();
					event.eventType = eventName;
				}
	
				event.eventName = eventName;
	
				if (document.createEvent) {
					el.dispatchEvent(event);
				} else {
					el.fireEvent('on' + event.eventType, event);
				}
			},
	
	
			/**
			 * Detects if an element is in the viewport.
			 * @param {Object} el - A DOM node.
			 * @see {@link http://stackoverflow.com/questions/123999/how-to-tell-if-a-dom-element-is-visible-in-the-current-viewport/7557433#7557433}
			 * @public
			 */
			isElementInViewport: function (el) {
				var rect = el.getBoundingClientRect();
	
				return (
					rect.top >= 0 &&
					rect.left >= 0 &&
					rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
					rect.right <= (window.innerWidth || document.documentElement.clientWidth)
				);
			},
	
	
			/**
			 * Detects if browser has support for the History API.
			 * @public
			 */
			hasHistorySupport: function () {
				return !!(window.history && history.pushState);
			},
	
	
			/**
			 * Returns a timestamp
			 * @public
			 */
			getTimestamp: function () {
				if (!Date.now) {
					return new Date().getTime();
				} else {
					return Date.now();
				}
			},
	
	
			/**
			 * DOMParser HTML extension for other browsers.
			 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/DOMParser}
			 * @public
			 */
			DOMParserPolyfill: function () {
				if (window.DOMParser !== undefined) {
					(function (DOMParser) {
						var proto = DOMParser.prototype,
							nativeParse = proto.parseFromString;
	
						// Firefox/Opera/IE throw errors on unsupported types
						try {
							// WebKit returns null on unsupported types
							if ((new DOMParser()).parseFromString('', 'text/html')) {
								// text/html parsing is natively supported
								return;
							}
						} catch (ex) {}
	
						proto.parseFromString = function (markup, type) {
							if (/^\s*text\/html\s*(?:;|$)/i.test(type)) {
								var doc = document.implementation.createHTMLDocument('');
	
								if (markup.toLowerCase().indexOf('<!doctype') > -1) {
									doc.documentElement.innerHTML = markup;
								} else {
									doc.body.innerHTML = markup;
								}
	
								return doc;
							} else {
								return nativeParse.apply(this, arguments);
							}
						};
					}(DOMParser));
				}
			},
	
	
			/**
			 * Polyfill requestAnimFrame.
			 * @see {@link http://www.paulirish.com/2011/requestanimationframe-for-smart-animating/}
			 * @private
			 */
			RAFPolyfill: function () {
				window.requestAnimFrame = (function () {
					return window.requestAnimationFrame ||
					window.webkitRequestAnimationFrame ||
					window.mozRequestAnimationFrame ||
					function (callback) {
						window.setTimeout(callback, 1000 / 60);
					};
				})();
			},
	
	
			/**
			 * Parse a form and creates an object with all the keys and values.
			 * @param {Object} form - A FORM DOM node.
			 * @see {@link https://plainjs.com/javascript/ajax/serialize-form-data-into-an-array-46/}
			 * @public
			 */
			formToArray: function (form) {
				var field, l, s = [];
	
				if (typeof form == 'object' && form.nodeName == 'FORM') {
					var len = form.elements.length;
	
					for (var i = 0; i < len; i++) {
						field = form.elements[i];
						if (field.name && !field.disabled && field.type != 'file' && field.type != 'reset' && field.type != 'submit' && field.type != 'button') {
							if (field.type == 'select-multiple') {
								l = form.elements[i].options.length;
								for (var j = 0; j < l; j++) {
									if (field.options[j].selected) {
										s[s.length] = { name: field.name, value: field.options[j].value };
									}
								}
							}
							else if ((field.type != 'checkbox' && field.type != 'radio') || field.checked) {
								s[s.length] = { name: field.name, value: field.value };
							}
						}
					}
				}
	
				return s;
			},
	
	
			/**
			 * Takes a form and creates a query-string from it's values.
			 * @param {Object} form - A FORM DOM node.
			 * @see {@link module:utilities.formToArray}
			 * @public
			 */
			formToQuery: function (form) {
				var data = this.formToArray(form),
					query = [];
	
				this.forEach(data, function (obj) {
					query.push(encodeURIComponent(obj.name) + '=' + encodeURIComponent(obj.value));
				});
	
				return query.join('&');
			},
	
	
			/**
			 * Adds/updates a url query parameter
			 * @param {String} url - The url.
			 * @param {String} param - The parameter name.
			 * @param {String} paramVal - The parameter value.
			 * @public
			 */
			updateURLParameter: function (url, param, paramVal) {
				var newAdditionalURL = '',
					tempArray = url.split('?'),
					baseURL = tempArray[0],
					additionalURL = tempArray[1],
					temp = '';
	
				if (additionalURL) {
					tempArray = additionalURL.split('&');
					for (var i = 0; i < tempArray.length; i++) {
						if (tempArray[i].split('=')[0] != param) {
							newAdditionalURL += temp + tempArray[i];
							temp = '&';
						}
					}
				}
	
				var rows_txt = temp + '' + param + '=' + paramVal;
				return baseURL + '?' + newAdditionalURL + rows_txt;
			},
	
	
			/**
			 * Returns the value of an object attribute based of the attribute "path" as an string.
			 * @param {Object} o - A object.
			 * @param {String} s - A string.
			 * @public
			 */
			objectByString: function (o, s) {
				s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
				s = s.replace(/^\./, '');           // strip a leading dot
				var a = s.split('.');
				for (var i = 0, n = a.length; i < n; ++i) {
					var k = a[i];
					if (k in o) {
						o = o[k];
					} else {
						return;
					}
				}
				return o;
			},
	
	
			/**
			 * Scrolls to Y-coordinate.
			 * @param {Number} scrollTargetYParam - The target scrollY property of the window
			 * @param {Number} speedParam - Time in pixels per second
			 * @param {String} easingParam - Easing equation to use
			 * @see {@link http://stackoverflow.com/a/26808520/5243250}
			 * @public
			 */
			scrollToY: function (scrollTargetYParam, speedParam, easingParam) {
				var scrollY = window.pageYOffset || document.documentElement.scrollTop,
					scrollTargetY = scrollTargetYParam || 0,
					speed = speedParam || 2000,
					easing = easingParam || 'easeOutSine',
					currentTime = 0,
					time, easingEquations;
	
				// min time 0.1, max time 0.8 seconds
				time = Math.max(0.1, Math.min(Math.abs(scrollY - scrollTargetY) / speed, 0.8));
	
				// easing equations from https://github.com/danro/easing-js/blob/master/easing.js
				easingEquations = {
					easeOutSine: function (pos) {
						return Math.sin(pos * (Math.PI / 2));
					},
					easeInOutSine: function (pos) {
						return (-0.5 * (Math.cos(Math.PI * pos) - 1));
					},
					easeInOutQuint: function (pos) {
						if ((pos /= 0.5) < 1) {
							return 0.5 * Math.pow(pos, 5);
						}
						return 0.5 * (Math.pow((pos - 2), 5) + 2);
					}
				};
	
				// add animation loop
				function tick () {
					currentTime += 1 / 60;
	
					var p = currentTime / time,
						t = easingEquations[easing](p);
	
					if (p < 1) {
						window.requestAnimFrame(tick);
						window.scrollTo(0, scrollY + ((scrollTargetY - scrollY) * t));
					} else {
						window.scrollTo(0, scrollTargetY);
					}
				}
	
				// call it once to get started
				tick();
			}
		};
	
	
		return utilities;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(5)], __WEBPACK_AMD_DEFINE_RESULT__ = function (utils, pubsub) {
		'use strict';
	
		/**
		 * Toggle link
		 * A plugin for making links toggle other content (with accessibility features).
		 * @version 1.1.3
		 * @exports toggleLink
		 */
		var toggleLink = {
	
			/**
			 * The initialization function for this module.
			 * @public
			 */
			init: function () {
				this._initToggleLink();
				this._initSubscriptions();
			},
	
	
			/**
			 * Add toggle feature to the links.
			 * @private
			 */
			_initToggleLink: function () {
				var that = this;
	
				utils.forEachElement('[data-type="toggle"]', function (el) {
					if (el.getAttribute('data-initiated') !== null) {
						return false;
					}
	
					if (el.tagName.toLowerCase() === 'a' && el.getAttribute('role') === null) {
						el.setAttribute('role', 'button');
					}
	
					el.setAttribute('data-initiated', true);
	
					utils.addEventListener(el, 'click', function (event) {
						var evt = event || window.event;
	
						if (this.getAttribute('type') !== 'submit') {
							if (evt.preventDefault !== undefined) { evt.preventDefault(); } else { evt.returnValue = false; }
						}
						if (this.getAttribute('type') !== 'submit' && this.getAttribute('disabled') === 'disabled') {
							return false;
						}
	
						that._toggleLink(this);
					});
	
					that._initValidation(el);
				});
			},
	
			/**
			 * Checks if element has required input fields and adds oninvalid event.
			 * @private
			 */
			_initValidation: function (el) {
				var that = this,
					requiredFields = document.getElementById(el.getAttribute('aria-controls')).querySelectorAll('input[required]');
	
				if (requiredFields) {
					utils.forEach(requiredFields, function (field) {
						utils.addEventListener(field, 'invalid', function () {
							if (el.getAttribute('aria-expanded') === 'false') {
								that._toggleLink(el);
							}
						});
					});
				}
			},
	
			/**
			 * The function that toggles the link.
			 * @private
			 */
			_toggleLink: function (el) {
				var that = this,
					target = document.getElementById(el.getAttribute('aria-controls')),
					currentState = target.getAttribute('aria-hidden') === 'true',
					currentText = el.innerHTML,
					nextText = el.getAttribute('data-toggletext') || null,
					group = target.getAttribute('data-togglegroup');
	
				// Close other toggles that are opened in this group.
				if (group !== undefined) {
					utils.forEachElement('[data-togglegroup="' + group + '"][aria-hidden="false"]', function (groupEl) {
						var groupElId = groupEl.getAttribute('id'),
							groupLinkEl = document.querySelector('[href="#' + groupElId + '"]') || document.querySelector('[aria-controls="' + groupElId + '"]');
	
						if (groupLinkEl !== null && groupLinkEl !== el) {
							that._toggleLink(groupLinkEl);
						}
					});
				}
	
				target.setAttribute('aria-hidden', !currentState);
				el.setAttribute('aria-expanded', currentState);
	
				if (nextText !== null) {
					el.setAttribute('data-toggletext', currentText);
					el.innerHTML = nextText;
				}
	
				utils.rerenderElement('lt-ie9');
	
				if (currentState === true) {
					utils.addClass(el, 'is-active');
					if (target.querySelector('input[type="text"]') !== null) {
						target.querySelector('input[type="text"]').focus();
					}
					else if (target.querySelector('input[type="search"]') !== null) {
						target.querySelector('input[type="search"]').focus();
					} else {
						if (target.getAttribute('tabindex') === null) {
							target.setAttribute('tabindex', '-1');
						}
						target.focus();
					}
				} else {
					utils.removeClass(el, 'is-active');
				}
			},
	
	
			/**
			 * Initiates subscriptions.
			 * @private
			 */
			_initSubscriptions: function () {
				var that = this;
	
				pubsub.subscribe('/ajaxForm/sync/updated', function () {
					that._initToggleLink();
				});
				pubsub.subscribe('/ajaxForm/list/updated', function () {
					that._initToggleLink();
				});
				pubsub.subscribe('/toggleLink', function (el) {
					that._toggleLink(el);
				});
			}
		};
	
	
		return toggleLink;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
		'use strict';
	
		/**
		 * Publish / Subscribe
		 * A event publish/subscribe widget.
		 * @version 1.0.0
		 * @see {@link https://davidwalsh.name/pubsub-javascript}
		 * @exports pubsub
		 */
		var pubsub = (function () {
			var topics = {},
				hOP = topics.hasOwnProperty;
	
			return {
				subscribe: function (topic, listener) {
					// Create the topic's object if not yet created
					if (!hOP.call(topics, topic)) {
						topics[topic] = [];
					}
	
					// Add the listener to queue
					var index = topics[topic].push(listener) - 1;
	
					// Provide handle back for removal of topic
					return {
						remove: function () {
							delete topics[topic][index];
						}
					};
				},
				publish: function (topic, info) {
					// If the topic doesn't exist, or there's no listeners in queue, just leave
					if (!hOP.call(topics, topic)) {
						return;
					}
	
					// Cycle through topics queue, fire!
					topics[topic].forEach(function (item) {
						item(info !== undefined ? info : {});
					});
				}
			};
		})();
	
		return pubsub;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(7)], __WEBPACK_AMD_DEFINE_RESULT__ = function (utils, hoverIntent) {
		'use strict';
	
		/**
		 * Dropdown
		 * A plugin for handeling dropdowns (with accessibility features).
		 * @exports dropdown
		 */
		var dropdown = {
	
			/** Delay settings for hoverIntent. */
			hoverIntentOptions: {
				timeout: 200,
				interval: 100
			},
	
	
			/**
			 * The initialization function for this module.
			 * @public
			 */
			init: function () {
				this._initDropdown();
			},
	
	
			/**
			 * Initiates dropdown functionality
			 * @private
			 */
			_initDropdown: function () {
				var that = this;
	
				utils.forEachElement('.has-dropdown', function (el) {
					el._dropdownTarget = el.querySelector('.dropdown');
					if (el._dropdownTarget !== undefined) {
						if (!Modernizr.touchevents) {
							that._initiateHoverIntent(el);
							that._initKeyboardNavigation(el);
						} else {
							that._initTouchHover(el);
						}
					}
				});
			},
	
	
			/**
			 * Initiates hoverIntent functionality
			 * @param {Object} el - The DOM object to add featue to.
			 * @private
			 */
			_initiateHoverIntent: function (el) {
				hoverIntent(el,
					function () {
						this._dropdownTarget.setAttribute('aria-hidden', false);
					}, function () {
						this._dropdownTarget.setAttribute('aria-hidden', true);
					}
				).options(this.hoverIntentOptions);
			},
	
	
			/**
			 * Fixes so hover works on touch devices.
			 * @param {Object} el - The DOM object to add featue to.
			 * @private
			 */
			_initTouchHover: function (el) {
				var childLink = el.querySelector('a');
	
				utils.addEventListener(el, 'click', function () {
					if (el._dropdownTarget.getAttribute('aria-hidden') === 'true') {
						utils.forEachElement('.dropdown', function (dropdownEl) {
							dropdownEl.setAttribute('aria-hidden', true);
						});
						el._dropdownTarget.setAttribute('aria-hidden', false);
					} else {
						el._dropdownTarget.setAttribute('aria-hidden', true);
					}
				});
	
				if (childLink !== undefined) {
					utils.addEventListener(childLink, 'click', function (event) {
						if (el._dropdownTarget.getAttribute('aria-hidden') === 'true' || this.getAttribute('href') === '#') {
							if (event.preventDefault) { event.preventDefault(); } else { event.returnValue = false; }
						}
					});
				}
			},
	
	
			/**
			 * Add keyboard tab navigation.
			 * @param {Object} el - The DOM object to add featue to.
			 * @private
			 */
			_initKeyboardNavigation: function (el) {
				// Open dropdown on first enterpress (open link on second)
				utils.addEventListener(el, 'keydown', function (event) {
					if (event.keyCode === 13 && this._dropdownTarget.getAttribute('aria-hidden') === 'true') {
						if (event.preventDefault) { event.preventDefault(); } else { event.returnValue = false; }
						var input = this._dropdownTarget.querySelectorAll('input')[0];
						this._dropdownTarget.setAttribute('aria-hidden', false);
	
						if (input !== undefined) {
							input.focus();
						}
					}
				});
	
				// Close dropdown on focus leave
				utils.addEventListener(el, 'blur', function () {
					el._focusoutTimer = setTimeout(function () {
						el._dropdownTarget.setAttribute('aria-hidden', true);
					}, 50);
				});
	
				utils.addEventListener(el, 'focus', function () {
					if (el._focusoutTimer !== undefined) {
						clearTimeout(el._focusoutTimer);
					}
				});
			}
		};
	
	
		return dropdown;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 7 */
/***/ (function(module, exports) {

	// https://github.com/tristen/hoverintent
	;(function(global) {
	
	var hoverintent = function(el, over, out) {
	  var x, y, pX, pY;
	  var h = {},
	    state = 0,
	    timer = 0;
	
	  var options = {
	    sensitivity: 7,
	    interval: 100,
	    timeout: 0
	  };
	
	  var defaults = function(opt) {
	    options = merge(opt || {}, options);
	  };
	
	  var merge = function(obj) {
	    for (var i = 1; i < arguments.length; i++) {
	      var def = arguments[i];
	      for (var n in def) {
	        if (obj[n] === undefined) obj[n] = def[n];
	      }
	    }
	    return obj;
	  };
	
	  // Cross browser events
	  var addEvent = function(object, event, method) {
	    if (object.attachEvent) {
	      object['e' + event + method] = method;
	      object[event + method] = function() {
	        object['e' + event + method](window.event);
	      };
	      object.attachEvent('on' + event, object[event + method]);
	    } else {
	      object.addEventListener(event, method, false);
	    }
	  };
	
	  var removeEvent = function(object, event, method) {
	    if (object.detachEvent) {
	      object.detachEvent('on' + event, object[event + method]);
	      object[event + method] = null;
	    } else {
	      object.removeEventListener(event, method, false);
	    }
	  };
	
	  var track = function(e) {
	    x = e.clientX;
	    y = e.clientY;
	  };
	
	  var delay = function(el, outEvent, e) {
	    if (timer) timer = clearTimeout(timer);
	    state = 0;
	    return outEvent.call(el, e);
	  };
	
	  var dispatch = function(e, event, over) {
	    var tracker = function(e) {
	      track(e);
	    };
	
	    if (timer) timer = clearTimeout(timer);
	    if (over) {
	      pX = e.clientX;
	      pY = e.clientY;
	      addEvent(el, 'mousemove', tracker);
	
	      if (state !== 1) {
	        timer = setTimeout(function() {
	          compare(el, event, e);
	        }, options.interval);
	      }
	    } else {
	      removeEvent(el, 'mousemove', tracker);
	
	      if (state === 1) {
	        timer = setTimeout(function() {
	          delay(el, event, e);
	        }, options.timeout);
	      }
	    }
	    return this;
	  };
	
	  var compare = function(el, overEvent, e) {
	    if (timer) timer = clearTimeout(timer);
	    if ((Math.abs(pX - x) + Math.abs(pY - y)) < options.sensitivity) {
	      state = 1;
	      return overEvent.call(el, e);
	    } else {
	      pX = x;
	      pY = y;
	      timer = setTimeout(function() {
	        compare(el, overEvent, e);
	      }, options.interval);
	    }
	  };
	
	  // Public methods
	  h.options = function(opt) {
	    defaults(opt);
	  };
	
	  var dispatchOver = function(e) {
	    dispatch(e, over, true);
	  };
	  var dispatchOut = function(e) {
	    dispatch(e, out);
	  };
	
	  h.remove = function() {
	    if (!el) return;
	    removeEvent(el, 'mouseover', dispatchOver);
	    removeEvent(el, 'mouseout', dispatchOut);
	  };
	
	  if (el) {
	    addEvent(el, 'mouseover', dispatchOver);
	    addEvent(el, 'mouseout', dispatchOut);
	  }
	
	  defaults();
	  return h;
	};
	
	global.hoverintent = hoverintent;
	if (typeof module !== 'undefined' && module.exports) module.exports = hoverintent;
	
	})(this);


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(5)], __WEBPACK_AMD_DEFINE_RESULT__ = function (utils, pubsub) {
		'use strict';
	
		/**
		 * Autosubmit
		 * A plugin that adds autosubmit functionality..
		 * @version 1.0.0
		 * @exports autoSubmit
		 */
		var autoSubmit = {
	
			/**
			 * The initialization function for this module.
			 * @public
			 */
			init: function () {
				this._initAutosubmit();
				this._initSubscriptions();
			},
	
	
			/**
			 * Function that initiates the autosubmit functionality.
			 * This can be used on an input to have it to submit the form on change.
			 * @private
			 */
			_initAutosubmit: function () {
				utils.forEachElement('[data-type="autosubmit"]', function (el) {
					if (el.getAttribute('data-initiated') !== null) {
						return false;
					}
	
					el.setAttribute('data-initiated', true);
	
					utils.addEventListener(el, 'change', function () {
						var form = el.form;
	
						if (form !== null) {
							utils.triggerEvent(form, 'submit');
						}
					});
				});
			},
	
	
			/**
			 * Initiates subscriptions.
			 * @private
			 */
			_initSubscriptions: function () {
				pubsub.subscribe('/ajaxForm/sync/updated', this._initAutosubmit);
			}
		};
	
	
		return autoSubmit;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = function (utils) {
		'use strict';
	
		/**
		 * checkboxRequiredGroup
		 * A plugin that adds validation to a group of checkboxes there one or more must be checked.
		 * @version 1.0.0
		 * @exports checkboxRequiredGroup
		 */
		var checkboxRequiredGroup = {
	
			/**
			 * The initialization function for this module.
			 * @public
			 */
			init: function () {
				this._initCheckboxRequiredGroup();
			},
	
	
			/**
			 * Function that initiates the checkbox group required functionality.
			 * @private
			 */
			_initCheckboxRequiredGroup: function () {
				var that = this;
	
				utils.forEachElement('[data-type="checkbox-required-group"]', function (el) {
					if (el.getAttribute('data-checkbox-required-group-initiated') !== null) {
						return false;
					}
					el.setAttribute('data-checkbox-required-group-initiated', true);
	
					var checkboxes = el.querySelectorAll('input[type="checkbox"]');
	
					utils.forEach(checkboxes, function (checkbox) {
						utils.addEventListener(checkbox, 'change', function () {
							that._setCheckboxesRequired(el);
						});
					});
					that._setCheckboxesRequired(el);
				});
			},
	
	
	
			/**
			 * Check all checkboxes and see if any is checked.
			 * If non is checked all will be marked as required with a custom validation message.
			 * @private
			 */
			_setCheckboxesRequired: function (el) {
				var anySelected = el.querySelectorAll('input[type="checkbox"]:checked').length > 0,
					checkboxes = el.querySelectorAll('input[type="checkbox"]');
	
				if (!anySelected) {
					utils.forEach(checkboxes, function (checkbox) {
						checkbox.setCustomValidity('En eller flera kryssrutor måste markeras.');
						checkbox.setAttribute('required', true);
					});
				} else {
					utils.forEach(checkboxes, function (checkbox) {
						checkbox.setCustomValidity('');
						checkbox.removeAttribute('required');
					});
				}
			}
		};
	
	
		return checkboxRequiredGroup;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(3),
		__webpack_require__(11)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function (utils, cookie) {
		'use strict';
	
		/**
		 * AcceptCookies
		 * A plugin that adds accept cookie functionality..
		 * @exports acceptCookies
		 */
		var acceptCookies = {
	
			/**
			 * The initialization function for this module.
			 * @public
			 */
			init: function () {
				this._initEvents();
			},
	
	
			/**
			 * Initiates events.
			 * @private
			 */
			_initEvents: function () {
				var els = document.querySelectorAll('[data-type="accept-cookie"]');
	
				if (els.length > 0) {
					utils.forEach(els, function (el) {
						utils.addEventListener(el, 'click', function (event) {
							if (event.preventDefault) { event.preventDefault(); } else { event.returnValue = false; }
	
							var target = document.getElementById(el.getAttribute('aria-controls')),
								cookieName = el.getAttribute('data-cookiename');
	
							cookie.setCookie(cookieName, true, 3650, '/');
	
							if (target !== null) {
								utils.addClass(target, 'is-animated');
	
								setTimeout(function () {
									utils.remove(target);
								}, 500);
							}
						});
					});
				}
			}
		};
	
	
		return acceptCookies;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
		'use strict';
	
		/**
		 * Cookie
		 * Widget to simplify cookie management.
		 * @see {@link http://www.w3schools.com/js/js_cookies.asp}
		 * @exports cookie
		 */
		var cookie = {
	
			/**
			 * Sets a cookie.
			 * @param {String} cname - The name of the cookie.
			 * @param {String} cvalue - The value of the cookie.
			 * @param {Number} exdays - The number of days until the cookie should expire.
			 * @public
			 */
			setCookie: function (cname, cvalue, exdays) {
				var d = new Date(),
					expires;
	
				d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
				expires = 'expires=' + d.toUTCString();
				document.cookie = cname + '=' + cvalue + '; ' + expires;
			},
	
	
			/**
			 * Gets a cookie.
			 * @param {String} cname - The name of the cookie.
			 * @public
			 */
			getCookie: function (cname) {
				var name = cname + '=',
					ca = document.cookie.split(';');
	
				for (var i = 0; i < ca.length; i++) {
					var c = ca[i];
					while (c.charAt(0) === ' ') {
						c = c.substring(1);
					}
					if (c.indexOf(name) === 0) {
						return c.substring(name.length, c.length);
					}
				}
	
				return '';
			}
		};
	
	
		return cookie;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 12 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {// Best place to find information on XHR features is:
	// https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest
	
	var reqfields = [
	  'responseType', 'withCredentials', 'timeout', 'onprogress'
	]
	
	// Simple and small ajax function
	// Takes a parameters object and a callback function
	// Parameters:
	//  - url: string, required
	//  - headers: object of `{header_name: header_value, ...}`
	//  - body:
	//      + string (sets content type to 'application/x-www-form-urlencoded' if not set in headers)
	//      + FormData (doesn't set content type so that browser will set as appropriate)
	//  - method: 'GET', 'POST', etc. Defaults to 'GET' or 'POST' based on body
	//  - cors: If your using cross-origin, you will need this true for IE8-9
	//
	// The following parameters are passed onto the xhr object.
	// IMPORTANT NOTE: The caller is responsible for compatibility checking.
	//  - responseType: string, various compatability, see xhr docs for enum options
	//  - withCredentials: boolean, IE10+, CORS only
	//  - timeout: long, ms timeout, IE8+
	//  - onprogress: callback, IE10+
	//
	// Callback function prototype:
	//  - statusCode from request
	//    + Possibly null or 0 (i.e. falsy) if an error occurs
	//  - response
	//    + if responseType set and supported by browser, this is an object of some type (see docs)
	//    + otherwise if request completed, this is the string text of the response
	//    + if request is aborted, this is "Abort"
	//    + if request times out, this is "Timeout"
	//    + if request errors before completing (probably a CORS issue), this is "Error"
	//  - request object
	//
	// Returns the request object. So you can call .abort() or other methods
	//
	// DEPRECATIONS:
	//  - Passing a string instead of the params object has been removed!
	//
	exports.ajax = function (params, callback) {
	  // Any variable used more than once is var'd here because
	  // minification will munge the variables whereas it can't munge
	  // the object access.
	  var headers = params.headers || {}
	    , body = params.body
	    , method = params.method || (body ? 'POST' : 'GET')
	    , called = false
	
	  var req = getRequest(params.cors)
	
	  function cb(statusCode, responseText) {
	    return function () {
	      if (!called) {
	        callback(req.status === undefined ? statusCode : req.status,
	                 req.status === 0 ? "Error" : (req.response || req.responseText || responseText),
	                 req)
	        called = true
	      }
	    }
	  }
	
	  req.open(method, params.url, true)
	
	  var success = req.onload = cb(200)
	  req.onreadystatechange = function () {
	    if (req.readyState === 4) success()
	  }
	  req.onerror = cb(null, 'Error')
	  req.ontimeout = cb(null, 'Timeout')
	  req.onabort = cb(null, 'Abort')
	
	  if (body) {
	    setDefault(headers, 'X-Requested-With', 'XMLHttpRequest')
	
	    if (!global.FormData || !(body instanceof global.FormData)) {
	      setDefault(headers, 'Content-Type', 'application/x-www-form-urlencoded')
	    }
	  }
	
	  for (var i = 0, len = reqfields.length, field; i < len; i++) {
	    field = reqfields[i]
	    if (params[field] !== undefined)
	      req[field] = params[field]
	  }
	
	  for (var field in headers)
	    req.setRequestHeader(field, headers[field])
	
	  req.send(body)
	
	  return req
	}
	
	function getRequest(cors) {
	  // XDomainRequest is only way to do CORS in IE 8 and 9
	  // But XDomainRequest isn't standards-compatible
	  // Notably, it doesn't allow cookies to be sent or set by servers
	  // IE 10+ is standards-compatible in its XMLHttpRequest
	  // but IE 10 can still have an XDomainRequest object, so we don't want to use it
	  if (cors && global.XDomainRequest && !/MSIE 1/.test(navigator.userAgent))
	    return new XDomainRequest
	  if (global.XMLHttpRequest)
	    return new XMLHttpRequest
	}
	
	function setDefault(obj, key, value) {
	  obj[key] = obj[key] || value
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*
	    JavaScript autoComplete v1.0.4
	    Copyright (c) 2014 Simon Steinberger / Pixabay
	    GitHub: https://github.com/Pixabay/JavaScript-autoComplete
	    License: http://www.opensource.org/licenses/mit-license.php
	*/
	
	var autoComplete = (function(){
	    // "use strict";
	    function autoComplete(options){
	        if (!document.querySelector) return;
	
	        // helpers
	        function hasClass(el, className){ return el.classList ? el.classList.contains(className) : new RegExp('\\b'+ className+'\\b').test(el.className); }
	
	        function addEvent(el, type, handler){
	            if (el.attachEvent) el.attachEvent('on'+type, handler); else el.addEventListener(type, handler);
	        }
	        function removeEvent(el, type, handler){
	            // if (el.removeEventListener) not working in IE11
	            if (el.detachEvent) el.detachEvent('on'+type, handler); else el.removeEventListener(type, handler);
	        }
	        function live(elClass, event, cb, context){
	            addEvent(context || document, event, function(e){
	                var found, el = e.target || e.srcElement;
	                while (el && !(found = hasClass(el, elClass))) el = el.parentElement;
	                if (found) cb.call(el, e);
	            });
	        }
	
	        var o = {
	            selector: 0,
	            source: 0,
	            minChars: 3,
	            delay: 150,
	            offsetLeft: 0,
	            offsetTop: 1,
	            cache: 1,
	            menuClass: '',
	            renderItem: function (item, search){
	                // escape special characters
	                search = search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	                var re = new RegExp("(" + search.split(' ').join('|') + ")", "gi");
	                return '<div class="autocomplete-suggestion" data-val="' + item + '">' + item.replace(re, "<b>$1</b>") + '</div>';
	            },
	            onSelect: function(e, term, item){}
	        };
	        for (var k in options) { if (options.hasOwnProperty(k)) o[k] = options[k]; }
	
	        // init
	        var elems = typeof o.selector == 'object' ? [o.selector] : document.querySelectorAll(o.selector);
	        for (var i=0; i<elems.length; i++) {
	            var that = elems[i];
	
	            // create suggestions container "sc"
	            that.sc = document.createElement('div');
	            that.sc.className = 'autocomplete-suggestions '+o.menuClass;
	
	            that.autocompleteAttr = that.getAttribute('autocomplete');
	            that.setAttribute('autocomplete', 'off');
	            that.cache = {};
	            that.last_val = '';
	
	            that.updateSC = function(resize, next){
	                var rect = that.getBoundingClientRect();
	                that.sc.style.left = Math.round(rect.left + (window.pageXOffset || document.documentElement.scrollLeft) + o.offsetLeft) + 'px';
	                that.sc.style.top = Math.round(rect.bottom + (window.pageYOffset || document.documentElement.scrollTop) + o.offsetTop) + 'px';
	                that.sc.style.width = Math.round(rect.right - rect.left) + 'px'; // outerWidth
	                if (!resize) {
	                    that.sc.style.display = 'block';
	                    if (!that.sc.maxHeight) { that.sc.maxHeight = parseInt((window.getComputedStyle ? getComputedStyle(that.sc, null) : that.sc.currentStyle).maxHeight); }
	                    if (!that.sc.suggestionHeight) that.sc.suggestionHeight = that.sc.querySelector('.autocomplete-suggestion').offsetHeight;
	                    if (that.sc.suggestionHeight)
	                        if (!next) that.sc.scrollTop = 0;
	                        else {
	                            var scrTop = that.sc.scrollTop, selTop = next.getBoundingClientRect().top - that.sc.getBoundingClientRect().top;
	                            if (selTop + that.sc.suggestionHeight - that.sc.maxHeight > 0)
	                                that.sc.scrollTop = selTop + that.sc.suggestionHeight + scrTop - that.sc.maxHeight;
	                            else if (selTop < 0)
	                                that.sc.scrollTop = selTop + scrTop;
	                        }
	                }
	            }
	            addEvent(window, 'resize', that.updateSC);
	            document.body.appendChild(that.sc);
	
	            live('autocomplete-suggestion', 'mouseleave', function(e){
	                var sel = that.sc.querySelector('.autocomplete-suggestion.selected');
	                if (sel) setTimeout(function(){ sel.className = sel.className.replace('selected', ''); }, 20);
	            }, that.sc);
	
	            live('autocomplete-suggestion', 'mouseover', function(e){
	                var sel = that.sc.querySelector('.autocomplete-suggestion.selected');
	                if (sel) sel.className = sel.className.replace('selected', '');
	                this.className += ' selected';
	            }, that.sc);
	
	            live('autocomplete-suggestion', 'mousedown', function(e){
	                if (hasClass(this, 'autocomplete-suggestion')) { // else outside click
	                    var v = this.getAttribute('data-val');
	                    that.value = v;
	                    o.onSelect(e, v, this);
	                    that.sc.style.display = 'none';
	                }
	            }, that.sc);
	
	            that.blurHandler = function(){
	                try { var over_sb = document.querySelector('.autocomplete-suggestions:hover'); } catch(e){ var over_sb = 0; }
	                if (!over_sb) {
	                    that.last_val = that.value;
	                    that.sc.style.display = 'none';
	                    setTimeout(function(){ that.sc.style.display = 'none'; }, 350); // hide suggestions on fast input
	                } else if (that !== document.activeElement) setTimeout(function(){ that.focus(); }, 20);
	            };
	            addEvent(that, 'blur', that.blurHandler);
	
	            var suggest = function(data){
	                var val = that.value;
	                that.cache[val] = data;
	                if (data.length && val.length >= o.minChars) {
	                    var s = '';
	                    for (var i=0;i<data.length;i++) s += o.renderItem(data[i], val);
	                    that.sc.innerHTML = s;
	                    that.updateSC(0);
	                }
	                else
	                    that.sc.style.display = 'none';
	            }
	
	            that.keydownHandler = function(e){
	                var key = window.event ? e.keyCode : e.which;
	                // down (40), up (38)
	                if ((key == 40 || key == 38) && that.sc.innerHTML) {
	                    var next, sel = that.sc.querySelector('.autocomplete-suggestion.selected');
	                    if (!sel) {
	                        next = (key == 40) ? that.sc.querySelector('.autocomplete-suggestion') : that.sc.childNodes[that.sc.childNodes.length - 1]; // first : last
	                        next.className += ' selected';
	                        that.value = next.getAttribute('data-val');
	                    } else {
	                        next = (key == 40) ? sel.nextSibling : sel.previousSibling;
	                        if (next) {
	                            sel.className = sel.className.replace('selected', '');
	                            next.className += ' selected';
	                            that.value = next.getAttribute('data-val');
	                        }
	                        else { sel.className = sel.className.replace('selected', ''); that.value = that.last_val; next = 0; }
	                    }
	                    that.updateSC(0, next);
	                    return false;
	                }
	                // esc
	                else if (key == 27) { that.value = that.last_val; that.sc.style.display = 'none'; }
	                // enter
	                else if (key == 13 || key == 9) {
	                    var sel = that.sc.querySelector('.autocomplete-suggestion.selected');
	                    if (sel && that.sc.style.display != 'none') { o.onSelect(e, sel.getAttribute('data-val'), sel); setTimeout(function(){ that.sc.style.display = 'none'; }, 20); }
	                }
	            };
	            addEvent(that, 'keydown', that.keydownHandler);
	
	            that.keyupHandler = function(e){
	                var key = window.event ? e.keyCode : e.which;
	                if (!key || (key < 35 || key > 40) && key != 13 && key != 27) {
	                    var val = that.value;
	                    if (val.length >= o.minChars) {
	                        if (val != that.last_val) {
	                            that.last_val = val;
	                            clearTimeout(that.timer);
	                            if (o.cache) {
	                                if (val in that.cache) { suggest(that.cache[val]); return; }
	                                // no requests if previous suggestions were empty
	                                for (var i=1; i<val.length-o.minChars; i++) {
	                                    var part = val.slice(0, val.length-i);
	                                    if (part in that.cache && !that.cache[part].length) { suggest([]); return; }
	                                }
	                            }
	                            that.timer = setTimeout(function(){ o.source(val, suggest) }, o.delay);
	                        }
	                    } else {
	                        that.last_val = val;
	                        that.sc.style.display = 'none';
	                    }
	                }
	            };
	            addEvent(that, 'keyup', that.keyupHandler);
	
	            that.focusHandler = function(e){
	                that.last_val = '\n';
	                that.keyupHandler(e)
	            };
	            if (!o.minChars) addEvent(that, 'focus', that.focusHandler);
	        }
	
	        // public destroy method
	        this.destroy = function(){
	            for (var i=0; i<elems.length; i++) {
	                var that = elems[i];
	                removeEvent(window, 'resize', that.updateSC);
	                removeEvent(that, 'blur', that.blurHandler);
	                removeEvent(that, 'focus', that.focusHandler);
	                removeEvent(that, 'keydown', that.keydownHandler);
	                removeEvent(that, 'keyup', that.keyupHandler);
	                if (that.autocompleteAttr)
	                    that.setAttribute('autocomplete', that.autocompleteAttr);
	                else
	                    that.removeAttribute('autocomplete');
	                document.body.removeChild(that.sc);
	                that = null;
	            }
	        };
	    }
	    return autoComplete;
	})();
	
	(function(){
	    if (true)
	        !(__WEBPACK_AMD_DEFINE_RESULT__ = function () { return autoComplete; }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    else if (typeof module !== 'undefined' && module.exports)
	        module.exports = autoComplete;
	    else
	        window.autoComplete = autoComplete;
	})();


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
		'use strict';
	
		/**
		 * Loader
		 * A plugin that displays a loader in a DOM node.
		 * @exports loader
		 */
		var loader = {
	
			/** String containing the html for the loader. */
			loaderStr: '<span class="loader"><span class="is-visuallyhidden">${screenreaderText}</span></span>',
	
			/** String containing the html for the large loader. */
			loaderLargeStr: '<span class="loader loader-large"><span class="is-visuallyhidden">${screenreaderText}</span></span>',
	
	
			/**
			 * Start loading.
			 * @param {Object} el - A DOM node.
			 * @param {String} screenreaderText - A string containing a text for screenreaders.
			 * @param {String} size - The size as a string ('large' for a large loader, anything else for a standard loader).
			 * @public
			 */
			loadingStart: function (el, screenreaderText, size, storeInnerHtml) {
				var loaderString = this.loaderStr;
	
				if (screenreaderText === undefined) {
					screenreaderText = '';
				}
	
				if (size !== undefined && size === 'large') {
					loaderString = this.loaderLargeStr;
				}
	
				loaderString = loaderString.replace('${screenreaderText}', screenreaderText);
	
				if (storeInnerHtml !== undefined) {
					el.setAttribute('data-innerhtml', el.innerHTML);
				}
	
				el.innerHTML = loaderString;
			},
	
	
			/**
			 * Stop loading.
			 * @param {Object} el - A DOM node.
			 * @public
			 */
			loadingEnd: function (el) {
				var oldHtml = el.getAttribute('data-innerhtml');
	
				if (oldHtml !== null) {
					el.innerHTML = el.getAttribute('data-innerhtml');
				}
			}
		};
	
	
		return loader;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// main.js